/**
 * Shared parsing for GET /club/operator/club/:clubId/operators responses.
 * An empty `operators` array means none have been invited yet.
 */

export function asClubOperatorsList(raw, depth = 0) {
  if (raw == null || depth > 6) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== "object") return [];

  const arrayKeys = [
    "operators",
    "items",
    "result",
    "results",
    "rows",
    "list",
    "users",
    "staff",
    "records",
    "data",
  ];
  for (let i = 0; i < arrayKeys.length; i += 1) {
    const v = raw[arrayKeys[i]];
    if (Array.isArray(v)) return v;
  }

  if (raw.data != null && typeof raw.data === "object") {
    const nested = asClubOperatorsList(raw.data, depth + 1);
    if (nested.length > 0) return nested;
  }

  return [];
}
